import React, { Component } from "react";

export default class Hero extends Component {
  componentDidMount() {
    var fullHeight = function () {
      window.$(".js-fullheight").css("height", window.$(window).height());
      window.$(window).resize(function () {
        window.$(".js-fullheight").css("height", window.$(window).height());
      });
    };
    fullHeight();

    var TxtRotate = function (el, toRotate, period) {
      this.toRotate = toRotate;
      this.el = el;
      this.loopNum = 0;
      this.period = parseInt(period, 10) || 2000;
      this.txt = "";
      this.tick();
      this.isDeleting = false;
    };

    TxtRotate.prototype.tick = function () {
      var i = this.loopNum % this.toRotate.length;
      var fullTxt = this.toRotate[i];

      if (this.isDeleting) {
        this.txt = fullTxt.substring(0, this.txt.length - 1);
      } else {
        this.txt = fullTxt.substring(0, this.txt.length + 1);
      }

      this.el.innerHTML = '<span class="wrap">' + this.txt + "</span>";

      var that = this;
      var delta = 300 - Math.random() * 100;

      if (this.isDeleting) {
        delta /= 2;
      }

      if (!this.isDeleting && this.txt === fullTxt) {
        delta = this.period;
        this.isDeleting = true;
      } else if (this.isDeleting && this.txt === "") {
        this.isDeleting = false;
        this.loopNum++;
        delta = 500;
      }

      setTimeout(function () {
        that.tick();
      }, delta);
    };
    window.onload = function () {
      var elements = document.getElementsByClassName("txt-rotate");
      for (var i = 0; i < elements.length; i++) {
        var toRotate = elements[i].getAttribute("data-rotate");
        var period = elements[i].getAttribute("data-period");
        if (toRotate) {
          new TxtRotate(elements[i], JSON.parse(toRotate), period);
        }
      }
      // INJECT CSS
      var css = document.createElement("style");
      css.type = "text/css";
      css.innerHTML = ".txt-rotate > .wrap { border-right: 0.08em solid #666 }";
      document.body.appendChild(css);
    };

    var contentWayPoint = function () {
      var i = 0;
      window.$(".ftco-animate").waypoint(
        function (direction) {
          if (
            direction === "down" &&
            !window.$(this.element).hasClass("ftco-animated")
          ) {
            i++;

            window.$(this.element).addClass("item-animate");
            setTimeout(function () {
              window.$("body .ftco-animate.item-animate").each(function (k) {
                var el = window.$(this);
                setTimeout(
                  function () {
                    var effect = el.data("animate-effect");
                    if (effect === "fadeIn") {
                      el.addClass("fadeIn ftco-animated");
                    } else if (effect === "fadeInLeft") {
                      el.addClass("fadeInLeft ftco-animated");
                    } else if (effect === "fadeInRight") {
                      el.addClass("fadeInRight ftco-animated");
                    } else {
                      el.addClass("fadeInUp ftco-animated");
                    }
                    el.removeClass("item-animate");
                  },
                  k * 50,
                  "easeInOutExpo"
                );
              });
            }, 100);
          }
        },
        { offset: "95%" }
      );
    };
    contentWayPoint();
  }
  render() {
    return (
      <>
        <section className="hero-wrap js-fullheight">
          <div className="overlay"></div>{" "}
          {/* Half of Left background color in the hero */}
          <div className="container">
            <div className="row no-gutters slider-text js-fullheight justify-content-center align-items-center">
              <div className="col-lg-8 col-md-6 ftco-animate d-flex align-items-center">
                <div className="text text-center">
                  <span className="subheading">Tongil Kim's</span>
                  <h1>RESUME</h1>
                  <h2>
                    <span
                      className="txt-rotate"
                      data-period="1300"
                      data-rotate='[ "Software Engineer" ]'
                    ></span>
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="mouse">
            <a href="#" className="mouse-icon">
              <div className="mouse-wheel">
                <span className="ion-ios-arrow-round-down"></span>
              </div>
            </a>
          </div>
        </section>
      </>
    );
  }
}
